module.exports = __webpack_public_path__ + "img/wx_app.a26527b2.svg";